import usePageHistory from '../../hooks/usePageHistory'
import Layout from '../../components/Layout'
import MonEspace from './MonEspace'
import RecapAnnuelSuperviseur from './RecapAnnuelSuperviseur'
import MesDisponibilites from './MesDisponibilites'
import MonPlanning from './MonPlanning'
import AssistanatSuperviseur from './AssistanatSuperviseur'

const PAGES = ['mon-planning', 'moneespace', 'assistanat-sup', 'mes-dispos', 'recap-annuel-sup']

export default function SuperviseurApp() {
  const [page, setPage] = usePageHistory(PAGES, 'mon-planning')
  return (
    <Layout activePage={page} onNavigate={setPage}>
      {page === 'moneespace' && <MonEspace />}
      {page === 'mon-planning' && <MonPlanning />}
      {page === 'assistanat-sup' && <AssistanatSuperviseur />}
      {page === 'mes-dispos' && <MesDisponibilites />}
      {page === 'recap-annuel-sup' && <RecapAnnuelSuperviseur />}
    </Layout>
  )
}
